export const CREATED_AT_ASC = 'CREATED_AT_ASC';
export const CREATED_AT_DESC = 'CREATED_AT_DESC';

export const QUESTIONS_SORT_OPTIONS = [
  {
    name: 'сначала новые',
    value: CREATED_AT_DESC,
  },
  {
    name: 'сначала старые',
    value: CREATED_AT_ASC,
  },
];

export const DEFAULT_QUESTIONS_SORT = 'CREATED_AT_DESC';
